import { Box, Stack, Typography, Chip } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { CalendarToday, AccessTime } from "@mui/icons-material";
import { useSelector } from "react-redux";

const ALL_CATEGORY = [
  {
    title_en: "Ecommerce",
    title_ro: "Comerț electronic",
    type: "ecommerce",
  },
  {
    title_en: "Cleaning Service",
    title_ro: "Serviciu de curatenie",
    type: "cleaning",
  },
  {
    title_en: "Car Service",
    title_ro: "Service auto",
    type: "car",
  },
];

const BlogsCard = ({ blogData, cardStyleProps = {} }) => {
  const navigate = useNavigate();
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 1) {
      return "Today";
    } else if (diffDays === 2) {
      return "Yesterday";
    } else if (diffDays < 7) {
      return `${diffDays - 1} days ago`;
    } else {
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
  };

  // Format reading time
  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const wordCount = content?.split(" ").length || 0;
    const readingTime = Math.ceil(wordCount / wordsPerMinute);
    return readingTime;
  };

  return (
    <Box
      onClick={() => {
        if (blogData?.slug) {
          navigate(`/blogs/${blogData.slug}`);
        }
      }}
      sx={{
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
        backgroundColor: "white",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
          "& .blog-image": {
            transform: "scale(1.05)",
          },
        },
        ...cardStyleProps,
      }}
    >
      {/* Image Container */}
      <Box
        sx={{
          position: "relative",
          height: 200,
          overflow: "hidden",
        }}
      >
        <img
          src={blogData?.image}
          alt={blogData?.title[currentLanguage]}
          className="blog-image"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.3s ease",
          }}
          loading="lazy"
        />

        {/* Category Chip */}
        {blogData?.category && (
          <Chip
            label={
              ALL_CATEGORY.find(
                (category) => category.type === blogData.category
              )?.[`title_${currentLanguage}`]
            }
            size="small"
            sx={{
              position: "absolute",
              top: 12,
              left: 12,
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              fontWeight: 600,
              fontSize: "0.75rem",
            }}
          />
        )}
      </Box>

      {/* Content Container */}
      <Box sx={{ p: 2.5 }}>
        {/* Date and Reading Time */}
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <CalendarToday sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: "0.75rem" }}
            >
              {formatDate(blogData?.createdAt)}
            </Typography>
          </Stack>

          {/* {blogData?.content && (
            <>
              <Typography variant="caption" color="text.secondary">
                •
              </Typography>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <AccessTime sx={{ fontSize: 16, color: "text.secondary" }} />
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.75rem" }}
                >
                  {calculateReadingTime(blogData.content)} min read
                </Typography>
              </Stack>
            </>
          )} */}
        </Stack>

        {/* Title */}
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{
            mb: 1.5,
            lineHeight: 1.3,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "2.6em",
          }}
        >
          {blogData?.title[currentLanguage]}
        </Typography>

        {/* Description */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            lineHeight: 1.5,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "4.5em",
          }}
        >
          {blogData?.smallDescription[currentLanguage]}
        </Typography>

        {/* Author Info (Optional) */}
        {/* {blogData?.author && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ mt: 2, pt: 1.5, borderTop: "1px solid #f0f0f0" }}
          >
            {blogData?.authorImage && (
              <Box
                component="img"
                src={blogData.authorImage}
                alt={blogData.author}
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )}
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontWeight: 500 }}
            >
              By {blogData.author}
            </Typography>
          </Stack>
        )} */}
      </Box>
    </Box>
  );
};

export default BlogsCard;
